import React, { Component } from "react";
import { StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import firebase from "firebase";
import "firebase/auth";
import {
  FirebaseAuthProvider,
  IfFirebaseAuthed,
  IfFirebaseUnAuthed,
} from "@react-firebase/auth";
import { config } from "../../config";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { translate } from "react-i18next"
import i18n from '../components/lang/i18n'


class Login extends Component {
  constructor(props) {
    super(props);
    this.i18n = i18n;
    this.showMessage = this.showMessage.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.handler = this.handler.bind(this)
    this.state = {
      message: "",
      isApp: false,
    };
  }

  handler() {
    this.setState({
      isApp: false,
    })
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  resetPassword() {
    var mail = prompt(i18n.t("login_reset_password_text", "Bitte gib deine Mail-Adresse ein:"), "");
    var auth = firebase.auth();
    if (mail && mail !== "") {
      auth.sendPasswordResetEmail(mail)
      .then(this.showMessage(i18n.t("login_reset_password_success", "E-Mail mit weiteren Anweisungen gesendet.")))
      .catch(function(error) {
        console.log(error);
      });
    }
  }


  render() {
    const { t } = this.props
    return (
      <StaticQuery
        query={graphql`
          query LoginQuery {
            site {
              siteMetadata {
                shortTitle
              }
            }
          }
        `}
        render={data => (
            <Layout cl="" handler={this.handler}>
            <Helmet>
                <title>{data.site.siteMetadata.shortTitle} - {t("login_title", "Anmelden")}</title>
                <meta name="description" content="Melde dich mit deinen Zugangsdaten bei WFOW an." />
            </Helmet>
              <div id="main" className={this.state.isApp ? 'pagefiller' : ''}>
                  <section id="one">
                      <div className="inner">
                          <header className="major">
                              <h1>{t("login_title", "Anmelden")}</h1>
                          </header>
                            <FirebaseAuthProvider {...config} firebase={firebase}>
                            <div>
                              <div>

                                <IfFirebaseUnAuthed>
                                  <Formik
                                  initialValues={{ email: '', password: '' }}
                                  validate={values => {
                                      const errors = {};
                                      if (!values.email) {
                                          errors.email = t("contact_form_mandatory", "* Pflichtfeld");
                                      } else if (
                                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                                      ) {
                                          errors.email = t("contact_form_mail_error", "Keine gültige Mail-Adresse");
                                      }
                                      if (!values.password) {
                                        errors.password = t("contact_form_mandatory", "* Pflichtfeld");
                                      }
                                      return errors;
                                  }}
                                  onSubmit={(values, { setSubmitting, resetForm, initialValues}) => {
                                      setTimeout(() => {
                                      //alert(JSON.stringify(values, null, 2));
                                      const errors = {};

                                      // LOGIN USER
                                        firebase.auth().signInWithEmailAndPassword(values.email, values.password)
                                        .then((userCredential) => {
                                          // Signed in
                                          var user = userCredential.user;
                                          console.log(user.email);
                                          firebase.analytics().logEvent('login', {
                                            method: user.email,
                                          });
                                        })
                                        .catch((error) => {
                                          var errorCode = error.code;
                                          var errorMessage = error.message;
                                          if (errorCode === "auth/user-not-found") {
                                              this.showMessage(t("login_error_user_not_found", "Es gibt keinen Benutzer mit dieser Mail-Adresse oder dieser wurde kürzlich gelöscht."));
                                          } else if (errorCode === "auth/wrong-password") {
                                              this.showMessage(t("login_error_wrong_password", "Das Passwort ist ungültig oder der Benutzer hat kein Passwort."));
                                          } else {
                                              console.log("ERROR " + errorCode + ": " + errorMessage);
                                              this.showMessage(t("login_error_unknown", "Ein unbekannter Fehler ist aufgetreten."));
                                          }
                                        });
                                      
                                      setSubmitting(false);
                                      //resetForm(initialValues)
                                      return errors;
                                      }, 400);
                                  }}
                                  >
                                  {({ isSubmitting, resetForm }) => (
                                      <Form>
                                          <div className="field half first">
                                              <label htmlFor="email">{t("login_mail", "Mail")}</label>
                                              <Field type="email" name="email"/>
                                              <ErrorMessage name="email" component="div" />
                                          </div>

                                          <div className="field half">
                                              <label htmlFor="password">{t("login_password", "Passwort")}</label>
                                              <Field type="password" name="password" />
                                              <ErrorMessage name="password" component="div" />
                                          </div>

                                          <div>
                                            <button type="submit" disabled={isSubmitting}>
                                              {t("login_login", "Anmelden")}
                                            </button>
                                            <br/><br/>
                                            <p>{this.state.message}</p>
                                            <br/>
                                            <a onClick={() => {this.resetPassword();}} href="#">{t("login_reset_password", "Passwort vergessen?")}</a>
                                          </div>
                                      </Form>
                                  )}
                                </Formik>

                                </IfFirebaseUnAuthed>

                                <IfFirebaseAuthed>
                                  {() => {
                                    return (
                                      <div>
                                        <div>{t("login_success", "Du hast dich erfolgreich angemeldet")}</div><br/>

                                        <ul className="actions">
                                          <li><a href="/profile" className="button special fit">{t("login_profile", "Mein Profil")}</a></li>
                                          <li><a onClick={() => {firebase.auth().signOut();}} href="/" className="button fit">{t("login_logout", "Abmelden")}</a></li>
                                        </ul>
                                    </div>
                                    );
                                  }}
                                </IfFirebaseAuthed>
      {/*                           <IfFirebaseAuthedAnd
                                  filter={({ providerId }) => providerId !== "anonymous"}
                                >
                                  {({ providerId }) => {
                                    return <div>Du hast dich erfolgreich angemeldet mit {providerId}</div>;
                                  }}
                                </IfFirebaseAuthedAnd> */}
                              </div>
                            </div>
                          </FirebaseAuthProvider>
                      </div>
                  </section>
              </div>
          </Layout>
            )}
            />
        )
    }
} 
export default translate("Index")(Login)